/*
 * @Author: alex (chenzeyongjsj@163.com)
 * @Date: 2018-11-17 02:20:12
 * @Last Modified by: alex (chenzeyongjsj@163.com)
 * @Last Modified time: 2019-04-27 12:57:09
 */
import axios from 'axios';
import qs from 'qs';

import { MessageBox } from 'element-ui';
import Messages from '@/utils/resetMessage';  // 按需引入

// 创建axios实例
const service = axios.create({
    withCredentials: true,
    baseURL: process.env.API_ROOT,
    // async: false,
    timeout: 15000 // 请求超时时间
});
// request拦截器
service.interceptors.request.use(
    config => {
        // qs序列化
        config.data && (config.data = qs.stringify(config.data));
        // 请求头部带上token
        const TOKEN = localStorage.getItem('idfadmin_token') || null;
        TOKEN && (config.headers['Api-Token'] = TOKEN);
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);
// respone拦截器
service.interceptors.response.use(
    response => {

        const res = response.data || null;
        if (res) {
            switch (res.code) {
                // 如果code为200则返回正确数据
                case 200:
                    return res;
                    break;
                // 如果code为404则返回正确数据
                case 400:
                    if (res.message) {
                        Messages.error(`${res.message}`);
                    }
                case 404:
                    return res;
                    break;
                // 登录过期
                case 401:
                    localStorage.removeItem('idfadmin_token');
                    MessageBox.confirm('您已离线', '提示', {
                        confirmButtonText: '重新登录',
                        showCancelButton: false,
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false,
                        type: 'warning'
                    }).then(() => {
                        location.reload(); // 重新实例化vue-router对象 避免bug
                    });
                    break;
                // other
                default:
                    if (res.code) {
                        Messages.error(`${res.message}`);
                    } else {
                        Messages.error('服务器错误!');
                    }
                    return false;
            }
        } else {
            return false;
        }
    },
    error => {
        if (
            error.code === 'ECONNABORTED' &&
            error.message.indexOf('timeout') !== -1
        ) {
            // 请求超时
            Messages.error('error');
            return false;
        }
        if (error.response.status === 404) {
            Messages.error(`${error.response.status} - ${error.response.statusText}`);

        } else if (error.response.status === 401) {
            localStorage.removeItem('idfadmin_token');
            MessageBox.confirm('您已离线', '提示', {
                confirmButtonText: '重新登录',
                showCancelButton: false,
                showClose: false,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                type: 'warning'
            }).then(() => {
                location.reload(); // 重新实例化vue-router对象 避免bug
            });

        } else if (error.response.status === 403) {
            // Messages.warning('您暂无权限访问');

        } else {
            Messages.error(`服务器错误：${error.response.status} - ${error.response.statusText}`);

        }
        return Promise.reject(error.response); // 返回接口返回的错误信息
    }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/http.js